/**
 * The income-statement Classifications that take a target on the `ISTargets` tab (PROD-648) — the
 * non-instrument P&L lines. `Posting` interest lines are simulated from the instruments and `Total`
 * rows roll up, so neither takes one. Luke's `IS_TARGET_CLASSES` (`brd_export.py` ~838).
 *
 * Measured on dev 2026-10-01: over CU ALM's income statement this is exactly Greg's 25 lines (the
 * 23 amounts, Credit Losses and Taxes), and over IRRM's exactly the 24 rows of Luke's 5KIR output.
 */
export const empyreanIncomeStatementTargetClassifications = ['Income/Expense', 'Intangible Inc/Exp'] as const;

export const isEmpyreanIncomeStatementTargetClassification = (classification: string | null | undefined): boolean =>
  !!classification &&
  (empyreanIncomeStatementTargetClassifications as readonly string[]).includes(classification.trim());

/**
 * One keyed monthly amount for one income-statement line (`emp.EmpyreanIncomeStatementTargets`,
 * PROD-648). Snapshotted per client AND per As Of Date, like the Manual Entries: each quarter stands
 * alone, and copy-from-previous-quarter seeds a new one on request.
 *
 * A line with no row is BLANK, and ships as an explicit 0 — a blank `ISTargets` cell would keep
 * whatever the model already held.
 */
export interface EmpyreanIncomeStatementTarget {
  id: number;
  portfolioCode: string;
  /** yyyy-MM-dd; the workspace As Of Date this snapshot belongs to */
  asOfDate: string;
  /** the governed income-statement line */
  almAccountNum: string;
  /** the MONTHLY figure as keyed, held flat across M1..M60. The file writes an expense line positive. */
  monthlyAmount: number;
}
